module.exports = __webpack_public_path__ + "img/Daniel Künzism.106fa894.jpg";